<template>
  <div class="subsidy-detail-modern">
    <!-- 顶部渐变背景 -->
    <div class="hero-gradient">
      <div class="hero-overlay"></div>
      <div class="container">
        <el-breadcrumb class="breadcrumb">
          <el-breadcrumb-item
            ><span class="breadcrumb_span" @click="backHome"
              >政务服务</span
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>补贴申领</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="hero-title">再生资源回收补贴申领</h1>
        <p class="hero-subtitle">绿色循环经济 · 政府财政支持 · 企业便捷申请</p>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区 -->
      <div class="content-wrapper">
        <!-- 左侧内容区 -->
        <div class="main-content">
          <!-- 政策卡片 -->
          <el-card shadow="hover" class="policy-card glassmorphism">
            <div class="card-header">
              <i class="el-icon-notebook-2 card-icon"></i>
              <h2>补贴政策信息</h2>
            </div>
            <p class="card-description">
              根据《再生资源回收利用补贴管理办法》，对符合条件的企业和个人提供回收补贴，促进资源循环利用。
            </p>

            <div class="policy-highlights">
              <div
                class="highlight-item"
                v-for="(item, index) in policyHighlights"
                :key="index"
              >
                <div
                  class="highlight-icon"
                  :style="{ backgroundColor: item.color }"
                >
                  <i :class="item.icon"></i>
                </div>
                <div class="highlight-content">
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.content }}</p>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 申请流程 -->
<!--          <el-card shadow="hover" class="process-card glassmorphism">-->
<!--            <div class="card-header">-->
<!--              <i class="el-icon-s-operation card-icon"></i>-->
<!--              <h2>申请流程</h2>-->
<!--            </div>-->
<!--            <div class="process-steps">-->
<!--              <div-->
<!--                class="process-step"-->
<!--                v-for="(step, index) in processSteps"-->
<!--                :key="index"-->
<!--              >-->
<!--                <div class="step-number">{{ index + 1 }}</div>-->
<!--                <div class="step-content">-->
<!--                  <h3 :style="{ color: step.color }">{{ step.title }}</h3>-->
<!--                  <p>{{ step.description }}</p>-->
<!--                  <div class="step-time" v-if="step.time">-->
<!--                    <i class="el-icon-time"></i> {{ step.time }}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-card>-->

          <!-- 申请按钮 -->
          <div class="action-buttons">
<!--            <el-button-->
<!--              type="primary"-->
<!--              round-->
<!--              class="apply-button"-->
<!--              @click="startApplication"-->
<!--            >-->
<!--              <i class="el-icon-s-claim"></i> 立即申请补贴-->
<!--            </el-button>-->
            <el-button round class="download-button" @click="downloadForm">
              <i class="el-icon-download"></i> 下载申请表
            </el-button>
          </div>
        </div>

        <!-- 右侧侧边栏 -->
        <div class="sidebar">
          <!-- 数据统计卡片 -->
          <el-card shadow="hover" class="stats-card glassmorphism">
            <div class="card-header">
              <i class="el-icon-data-line card-icon"></i>
              <h2>补贴数据统计</h2>
            </div>
            <div class="stats-grid">
              <div
                class="stat-item"
                v-for="stat in subsidyStats"
                :key="stat.id"
              >
                <div class="stat-value" :style="{ color: stat.color }">
                  {{ stat.value }}
                </div>
                <div class="stat-label">{{ stat.label }}</div>
                <div class="stat-trend" :class="stat.trend">
                  <i :class="stat.trendIcon"></i> {{ stat.trendValue }}
                </div>
              </div>
            </div>
          </el-card>

          <!-- 相关服务 -->
          <el-card shadow="hover" class="related-services-card glassmorphism">
            <div class="card-header">
              <i class="el-icon-connection card-icon"></i>
              <h2>相关服务</h2>
            </div>
            <div class="service-grid">
              <div
                class="service-item"
                v-for="service in relatedServices"
                :key="service.id"
                @click="$router.push(service.path)"
                :style="{ backgroundColor: service.bgColor }"
              >
                <div class="service-icon">
                  <i :class="service.icon"></i>
                </div>
                <h3>{{ service.title }}</h3>
                <p>{{ service.description }}</p>
              </div>
            </div>
          </el-card>

          <!-- 常见问题 -->
          <el-card shadow="hover" class="faq-card glassmorphism">
            <div class="card-header">
              <i class="el-icon-question card-icon"></i>
              <h2>常见问题</h2>
            </div>
            <el-collapse accordion class="faq-collapse">
              <el-collapse-item
                v-for="(faq, index) in faqs"
                :key="index"
                :title="faq.question"
                :name="index"
              >
                <div v-html="faq.answer"></div>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/util/scrollTop';

export default {
  name: 'SubsidyDetailModern',
  data() {
    return {
      policyHighlights: [
        {
          icon: 'el-icon-s-order',
          title: '补贴标准',
          content:
            '报废汽车回收：¥800-1500元/辆；废弃电子产品：¥50-200元/台；废旧金属回收：¥200-500元/吨；废纸回收：¥100-300元/吨',
          color: '#409EFF',
        },
        {
          icon: 'el-icon-s-check',
          title: '申请条件',
          content:
            '在本地注册并备案的再生资源回收企业；回收处理过程符合环保要求；提供完整的回收处理记录；按时报送相关统计报表',
          color: '#67C23A',
        },
        {
          icon: 'el-icon-s-data',
          title: '申请材料',
          content:
            '企业营业执照复印件；再生资源回收备案证明；回收处理明细表；环保达标证明；补贴申请表',
          color: '#E6A23C',
        },
      ],
      processSteps: [
        {
          title: '了解政策',
          description: '阅读并确认您了解补贴政策',
          time: '',
          color: '#409EFF',
        },
        {
          title: '准备材料',
          description: '收集所需申请材料',
          time: '1-2个工作日',
          color: '#67C23A',
        },
        {
          title: '在线申请',
          description: '填写申请表并上传材料',
          time: '',
          color: '#E6A23C',
        },
        {
          title: '等待审核',
          description: '通常需要5-10个工作日',
          time: '5-10个工作日',
          color: '#F56C6C',
        },
        {
          title: '补贴发放',
          description: '审核通过后发放补贴',
          time: '10个工作日内',
          color: '#9966CC',
        },
      ],
      subsidyStats: [
        {
          id: 1,
          value: '¥3,568万',
          label: '累计发放补贴',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '12.5% ↑',
          color: '#409EFF',
        },
        {
          id: 2,
          value: '1,258',
          label: '报废汽车补贴',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '8.3% ↑',
          color: '#67C23A',
        },
        {
          id: 3,
          value: '8,742',
          label: '电子产品补贴',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '15.2% ↑',
          color: '#E6A23C',
        },
        {
          id: 4,
          value: '326家',
          label: '受惠企业',
          trend: 'up',
          trendIcon: 'el-icon-top',
          trendValue: '5.7% ↑',
          color: '#9966CC',
        },
      ],
      relatedServices: [
        {
          id: 1,
          title: '报废汽车回收',
          description: '报废汽车回收流程与补贴',
          icon: 'el-icon-truck',
          path: '/scrap-car',
          bgColor: 'rgba(64, 158, 255, 0.1)',
        },
        {
          id: 2,
          title: '废弃电子产品',
          description: '电子废弃物回收处理指南',
          icon: 'el-icon-cpu',
          path: '/e-waste',
          bgColor: 'rgba(103, 194, 58, 0.1)',
        },
        {
          id: 3,
          title: '以旧换新',
          description: '家电以旧换新补贴政策',
          icon: 'el-icon-refresh',
          path: '/trade-in',
          bgColor: 'rgba(230, 162, 60, 0.1)',
        },
        {
          id: 4,
          title: '政策查询',
          description: '最新再生资源政策法规',
          icon: 'el-icon-notebook-2',
          path: '/policy',
          bgColor: 'rgba(153, 102, 204, 0.1)',
        },
      ],
      faqs: [
        {
          question: '哪些企业可以申请再生资源回收补贴？',
          answer:
            '在本地注册并完成再生资源回收备案的企业均可申请。具体包括：<br>1. 持有有效营业执照的企业<br>2. 已完成再生资源回收经营备案<br>3. 环保设施达标并通过验收<br>4. 有完整的回收处理记录',
        },
        {
          question: '补贴申请需要多长时间审批？',
          answer:
            '补贴审批时间通常为5-10个工作日：<br>1. 材料初审：1-2个工作日<br>2. 现场核查：3-5个工作日<br>3. 审批决定：2-3个工作日<br>高峰期可能会有适当延长',
        },
        {
          question: '补贴资金如何发放？',
          answer:
            '补贴资金将通过银行转账方式发放：<br>1. 审核通过后5个工作日内发放<br>2. 直接转入申请企业提供的银行账户<br>3. 发放后会短信通知企业联系人<br>4. 可在"我的申请"中查看发放状态',
        },
        {
          question: '补贴申请被拒绝后可以重新申请吗？',
          answer:
            '可以，但需要根据拒绝原因补充或修改材料：<br>1. 材料不全：补充完整后重新提交<br>2. 不符合条件：整改达标后可重新申请<br>3. 数据不实：核实数据后可重新申请<br>每次申请间隔不少于15个工作日',
        },
      ],
    };
  },
  mounted() {
    scrollTop();
  },
  methods: {
    startApplication() {
      this.$router.push('/subsidy/apply');
    },
    downloadForm() {
      this.$message.success('申请表下载开始');
      // 实际项目中调用下载接口
    },
    backHome() {
      this.$emit('goBack', '');
    },
  },
};
</script>

<style lang="less" scoped>
.subsidy-detail-modern {
  background-color: #f8fafc;
  min-height: 100vh;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

/* 顶部渐变背景 */
.hero-gradient {
  background: url('~@/assets/recycling/componyImages/ziyuanhuishoubutie.png')
  center;
  background-size: cover;
  color: white;
  padding: 120px 0 120px;
  margin-bottom: -40px;
  position: relative;
  overflow: hidden;
}
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      135deg,
      rgba(64, 158, 255, 0.8) 0%,
      rgba(103, 194, 58, 0.6) 100%
  );
  z-index: 0;
}

.breadcrumb {
  margin-bottom: 20px;
  .breadcrumb_span {
    color: #000000;
    font-weight: 500;
    cursor: pointer;
  }
}

.breadcrumb /deep/ .el-breadcrumb__item {
  color: rgba(255, 255, 255, 0.7);
}

.breadcrumb /deep/ .el-breadcrumb__item:last-child {
  color: white;
  font-weight: bold;
}

.breadcrumb /deep/ .el-breadcrumb__separator {
  color: rgba(255, 255, 255, 0.7);
}

.hero-title {
  font-size: 36px;
  font-weight: 600;
  margin: 0 0 10px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 18px;
  opacity: 0.9;
  margin: 0;
  font-weight: 300;
}

/* 内容布局 */
.content-wrapper {
  display: flex;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  min-width: 0;
}

.sidebar {
  width: 360px;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .content-wrapper {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }
}

/* 卡片设计 */
.glassmorphism {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.el-card {
  border: none;
  border-radius: 12px;
  margin-bottom: 24px;
}

.el-card /deep/ .el-card__body {
  padding: 24px;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.card-icon {
  font-size: 24px;
  color: #409eff;
  margin-right: 12px;
  background: rgba(64, 158, 255, 0.1);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-header h2 {
  font-size: 20px;
  margin: 0;
  color: #333;
}

.card-description {
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
}

/* 政策亮点 */
.policy-highlights {
  display: grid;
  gap: 16px;
}

.highlight-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: rgba(250, 250, 252, 0.8);
  border-radius: 8px;
  transition: all 0.3s;
}

.highlight-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.highlight-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  margin-right: 16px;
  flex-shrink: 0;
}

.highlight-content h3 {
  font-size: 16px;
  margin: 0 0 8px;
  color: #333;
}

.highlight-content p {
  font-size: 14px;
  margin: 0;
  color: #666;
  line-height: 1.5;
}

/* 申请流程 */
.process-steps {
  display: grid;
  gap: 16px;
}

.process-step {
  display: flex;
  position: relative;
  padding-left: 56px;
}

.process-step::before {
  content: '';
  position: absolute;
  left: 28px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, #409eff, #9966cc);
}

.process-step:last-child::before {
  display: none;
}

.step-number {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  border: 2px solid #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #409eff;
  z-index: 1;
}

.step-content {
  padding-bottom: 24px;
}

.step-content h3 {
  font-size: 16px;
  margin: 0 0 8px;
  font-weight: 600;
}

.step-content p {
  font-size: 14px;
  margin: 0 0 8px;
  color: #666;
}

.step-time {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}

.step-time i {
  margin-right: 4px;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 16px;
  margin-top: 32px;
}

.apply-button {
  padding: 12px 24px;
  font-size: 16px;
  background: linear-gradient(90deg, #409eff, #66b1ff);
  border: none;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

.download-button {
  padding: 12px 24px;
  font-size: 16px;
  background: white;
  border: 1px solid #dcdfe6;
}

/* 统计数据 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.stat-item {
  background: rgba(250, 250, 252, 0.8);
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  transition: all 0.3s;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.stat-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-trend i {
  margin-right: 4px;
}

.stat-trend.up {
  color: #67c23a;
}

.stat-trend.down {
  color: #f56c6c;
}

/* 相关服务 */
.service-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.service-item {
  padding: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.service-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.service-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
}

.service-item h3 {
  font-size: 14px;
  margin: 0 0 4px;
  color: #333;
}

.service-item p {
  font-size: 12px;
  margin: 0;
  color: #666;
  line-height: 1.4;
}

/* 常见问题 */
.faq-collapse /deep/ .el-collapse-item__header {
  font-size: 15px;
  font-weight: 500;
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
}

.faq-collapse /deep/ .el-collapse-item__content {
  padding: 12px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 28px;
  }

  .hero-subtitle {
    font-size: 16px;
  }

  .stats-grid,
  .service-grid {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .apply-button,
  .download-button {
    width: 100%;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.policy-card,
.process-card,
.stats-card,
.related-services-card,
.faq-card {
  animation: fadeIn 0.5s ease-out forwards;
}

.policy-card {
  animation-delay: 0.1s;
}
.process-card {
  animation-delay: 0.2s;
}
.stats-card {
  animation-delay: 0.3s;
}
.related-services-card {
  animation-delay: 0.4s;
}
.faq-card {
  animation-delay: 0.5s;
}
</style>
